import React from "react";
import styled from "styled-components";
import { FaMapMarkerAlt } from "react-icons/fa";

const PageHeaderWrapper = styled.div`
  position: relative;
  background-image: url(${(props) => props.backgroundImage});
  background-size: cover;
  background-position: center;
  height: 400px;
  border-radius: 12px;
  display: flex;
  align-items: center;
  color: white;
  padding: 20px;
`;

const Overlay = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.7); /* Dark overlay */
  border-radius: 12px;
`;

const Content = styled.div`
  position: relative;
  z-index: 2;
  max-width: 600px;
`;

const Title = styled.h1`
  font-size: 3rem;
  font-weight: bold;
  line-height: 1.2;
  margin: 0;

  span {
    display: block;
    color:  #ff5757; 
    
  }
`;

const Paragraph = styled.p`
  font-size: 1.2rem;
  line-height: 1.6;
  margin: 20px 0;
`;

const Button = styled.button`
  display: flex;
  align-items: center;
  background-color: #0056d2;
  color: white;
  border: none;
  padding: 10px 20px;
  font-size: 1rem;
  border-radius: 8px;
  cursor: pointer;
  transition: background-color 0.3s;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);

  &:hover {
    background-color: #003a9b;
  }

  svg {
    margin-right: 8px;
  }
`;

function PageHeader({ title, subtitle, description, buttonText, buttonAction, backgroundImage }) {
  return (
    <PageHeaderWrapper backgroundImage={backgroundImage}>
      <Overlay />
      <Content>
        <Title>
          {title} <span>{subtitle}</span>
        </Title>
        <Paragraph>{description}</Paragraph>
        <Button onClick={buttonAction}>
          <FaMapMarkerAlt />
          {buttonText}
        </Button>
      </Content>
    </PageHeaderWrapper>
  );
}

export default PageHeader;
